import React, { useEffect, memo, Fragment, useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import { useSelector } from "react-redux";
import * as SettingSelector from "../../store/setting/selectors";
import { DashboardAPI } from "../../js/api";

const StatCard = ({ title, value, color }) => (
  <Card className="shadow-sm border-0 mb-3">
    <Card.Body>
      <h6 className="text-muted mb-2">{title}</h6>
      <h3 style={{ color }}>{value}</h3>
    </Card.Body>
  </Card>
);

const Index = memo(() => {
  useSelector(SettingSelector.theme_color);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetchDashboard();
    AOS.init({ once: true, duration: 700 });
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await DashboardAPI.getDashboardData();
      setStats(res.data.data.data); // fix nested structure
    } catch (err) {
      console.error("Dashboard error:", err);
    }
  };

  const colors = {
    primary: "#0d6efd",
    success: "#198754",
    warning: "#ffc107",
    danger: "#dc3545",
    info: "#0dcaf0",
  };

  return (
    <Fragment>
      <Row>
        {/* SHOPS */}
        <Col md={3}>
          <StatCard
            title="Total Shops"
            value={stats?.shops?.total || 0}
            color={colors.primary}
          />
        </Col>
        <Col md={3}>
          <StatCard
            title="Active Shops"
            value={stats?.shops?.active || 0}
            color={colors.success}
          />
        </Col>

        {/* LISTINGS */}
        <Col md={3}>
          <StatCard
            title="Total Listings"
            value={stats?.listings?.total || 0}
            color={colors.info}
          />
        </Col>
        <Col md={3}>
          <StatCard
            title="Active Listings"
            value={stats?.listings?.active || 0}
            color={colors.success}
          />
        </Col>
      </Row>

      <Row>
        {/* DATA HEALTH */}
        <Col md={4}>
          <StatCard
            title="Listings Missing Data"
            value={stats?.listings?.missing_data || 0}
            color={colors.warning}
          />
        </Col>

        {/* TODAY UPDATES */}
        <Col md={4}>
          <StatCard
            title="Updated Today"
            value={stats?.updates_today?.updated || 0}
            color={colors.success}
          />
        </Col>
        <Col md={4}>
          <StatCard
            title="Errors Today"
            value={stats?.updates_today?.errors || 0}
            color={colors.danger}
          />
        </Col>
      </Row>

      <Row>
        {/* GOLD PRICE */}
        <Col md={6}>
          <Card className="shadow-sm border-0 mb-3">
            <Card.Body>
              <h6 className="text-muted">Current Gold Price (24KT)</h6>
              <h2 className="text-primary">₹{stats?.gold?.last_price || 0}</h2>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card className="shadow-sm border-0 mb-3">
            <Card.Body>
              <h6 className="text-muted">Gold Price Change</h6>
              <h2
                style={{
                  color:
                    stats?.gold?.difference > 0
                      ? colors.success
                      : colors.danger,
                }}
              >
                ₹{stats?.gold?.difference || 0}
              </h2>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* FOOTER — unchanged */}
      <footer style={{ marginTop: "300px" }}>
        <div className="footer-body justify-content-center mt-2 mb-2 text-center">
          <p
            style={{ fontSize: "14px", color: "#000", fontWeight: "500" }}
            className="m-0"
          >
            This is a private internal tool used only by the shop owner and
            authorized administrators. This application uses the Etsy API but is
            not endorsed or certified by Etsy.
          </p>
        </div>
      </footer>
    </Fragment>
  );
});

export default Index;
